import PropTypes from "prop-types";
import {Dropdown} from "primereact/dropdown";



export function GroupByDepartmentSelect(props) {

    const handleChange = (event) => {
        const myValue =props.groupList.find(x=>x.id===event.target.value)
        props.setGroup(myValue);

    };

    return (

            <Dropdown value={props.group.id} onChange={handleChange} options={props.groupList}
                      optionLabel="name" optionValue="id" disabled={props.disable}
                     variant="filled" className="flex w-full h-2rem md:w-4  align-items-center"  />

    )

}
GroupByDepartmentSelect.propTypes = {
    groupList: PropTypes.array.isRequired,
    group: PropTypes.object.isRequired,
    setGroup: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,


}
